'use strict';
const _ = require('underscore');
const Backbone = require('backbone');

const repositories = {};

class Repository {
    constructor(project) {
        this._project = project;
        this._works = new Backbone.Collection();
    }

    add(work) {
        return this._works.add(work, {merge: true});
    }

    getByIds(workIds) {
        return this._works.filter(w => _.contains(workIds, w.id));
    }

    static find(project) {
        let r = repositories[project.id];
        if (!r) {
            r = new Repository(project);
            repositories[project.id] = r;
        }
        return r;
    }
}

module.exports = Repository;



// WEBPACK FOOTER //
// ./process/domain/repository/work/index.js